import { createContext, useContext, useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [userRol, setUserRol] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchRol = async (userId) => {
    if (!userId) { setUserRol(null); return }
    const { data } = await supabase
      .from('voluntarios')
      .select('rol')
      .eq('auth_id', userId)
      .single()
    setUserRol(data?.rol || 'voluntario')
  }

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      if (session?.user) fetchRol(session.user.id)
      setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user ?? null)
        if (session?.user) fetchRol(session.user.id)
        else setUserRol(null)
        setLoading(false)
      }
    )

    return () => subscription.unsubscribe()
  }, [])

  const login = async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) throw error
    return data
  }

  const logout = async () => {
    const { error } = await supabase.auth.signOut()
    if (error) throw error
  }

  const register = async (email, password, userData) => {
    const { data, error } = await supabase.auth.signUp({
      email, password,
      options: { data: userData }
    })
    if (error) throw error
    return data
  }

  return (
    <AuthContext.Provider value={{ user, userRol, loading, login, logout, register }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth debe usarse dentro de AuthProvider')
  return context
}